module.exports = __webpack_public_path__ + "img/contact.ba3f899d.jpg";